/* @flow */
import React, { useContext } from 'react';
import TodoListDone from 'core/views/TodoListDone';
import MultiSelectContext, { withMultiSelectProvider } from 'core/contexts/MultiSelect';


export default withMultiSelectProvider(
  (props) => {
    const { isEnabled } = useContext(MultiSelectContext),
          headerComponentOffset = isEnabled ? 72 + 56 : 72;

    return <TodoListDone {...props} headerComponentOffset={headerComponentOffset} />;
  },
);
